<template>
  <div class="content mt-n6">
    <div class="md-layout">
      <v-btn icon>
        <v-icon @click="toggleSidebar()"> mdi-dots-vertical </v-icon>
      </v-btn>
      <v-row class="md-layout-item md-medium-size-100">
        <v-col cols="12" lg="4">
          <v-card
            rounded="lg"
            height="250"
            :style="{ background: $vuetify.theme.themes[theme].background }"
          >
            <v-card-title>Change Times/hr</v-card-title>
            <v-sheet
              class="ma-0 pa-0 mt-15"
              :style="{ background: $vuetify.theme.themes[theme].background }"
            >
              <v-sparkline
                :value="value"
                :gradient="gradient"
                :smooth="radius || false"
                :padding="padding"
                :line-width="width"
                :stroke-linecap="lineCap"
                :gradient-direction="gradientDirection"
                :fill="fill"
                :type="type"
                :auto-line-width="autoLineWidth"
                auto-draw
              ></v-sparkline>
            </v-sheet>
          </v-card>
        </v-col>

        <v-col cols="12" lg="4">
          <v-card
            rounded="lg"
            height="250"
            :style="{ background: $vuetify.theme.themes[theme].background }"
          >
            <v-card-title>Change Graph</v-card-title>
            <v-sheet
              class="ma-0 pa-0 mt-15"
              :style="{ background: $vuetify.theme.themes[theme].background }"
            >
              <bars
                :key="eee"
                :data="[1, 2, 5, 9, 5, 10, 3, 5, 2, 5, 1, 8, 2, 9, 0]"
                :gradient="['#3a86ff', '#b8f2e6']"
                :barWidth="4"
                :rounding="2"
                labelColor="#ffbe88"
                :labelRotate="45"
                :labelSize="0.2"
                :growDuration="1"
              >
              </bars>
            </v-sheet>
            <!-- :data="[{value: 1, title: '#1'}, {value: 2, title: '#2'}, ... ]" -->
          </v-card>
        </v-col>

        <v-col cols="12" lg="4">
          <v-card
            rounded="lg"
            height="250"
            :style="{ background: $vuetify.theme.themes[theme].background }"
          >
            <v-card-title>Change Times/hr</v-card-title>
            <v-sheet
              class="ma-0 pa-0 mt-15"
              :style="{ background: $vuetify.theme.themes[theme].background }"
            >
              <v-sparkline
                :value="value"
                :gradient="gradient"
                :smooth="radius || false"
                :padding="padding"
                :line-width="width"
                :stroke-linecap="lineCap"
                :gradient-direction="gradientDirection"
                :fill="fill"
                :type="type"
                :auto-line-width="autoLineWidth"
                auto-draw
              ></v-sparkline>
            </v-sheet>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" lg="3">
          <v-card
            elevation="9"
            height="100"
            rounded="xl"
            :style="{ background: $vuetify.theme.themes[theme].background }"
          >
            <div class="pl-5 pt-6">
              <circlecounter
                size="4rem"
                dash-spacing="0"
                stroke-width="6"
                active-width="18"
                active-count="-35"
                rotate="-160"
                stroke="transparent"
                activeStroke=" #46a3fa"
              >
              </circlecounter>
            </div>
            <div class="pl-3" style="position: absolute; bottom: 0">
              <circlecounter
                size="5rem"
                dash-spacing="0"
                stroke-width="6"
                active-width="18"
                active-count="-34"
                rotate="-140"
                stroke="transparent"
                activeStroke="#1250b8"
              >
              </circlecounter>
            </div>
            <div style="position: absolute; bottom: 22px; left: 38px">
              <p style="font-weight: 600">208</p>
            </div>
            <div style="position: absolute; bottom: 1px; left: 88px">
              <p style="font-size: 10px">137%</p>
            </div>
            <div
              class="mt-n7 mr-3"
              style="position: absolute; top: 0; right: 0"
            >
              <v-card
                width="200"
                height="90"
                color="transparent"
                elevation="0"
                justify="center"
                align="center"
              >
                <v-row justify="center" align="center">
                  <v-col justify="center" align="center">
                    <p style="font-size: 12px">
                      208 tasks are already completed. This is pretty good guys!
                    </p>
                  </v-col>
                </v-row>
              </v-card>
            </div>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" lg="3">
          <v-card
            elevation="9"
            height="100"
            rounded="xl"
            :style="{ background: $vuetify.theme.themes[theme].background }"
          >
            <div
              class="ml-12 mb-3"
              style="position: absolute; left: 0; bottom: 0"
            >
              <v-card
                width="40"
                height="40"
                color="#1250b8"
                style="border-radius: 5px"
                ><p style="font-size: 12px" class="ml-2 pt-3">304</p></v-card
              >
            </div>
            <div
              class="ml-7 mb-3"
              style="position: absolute; left: 0; bottom: 0"
            >
              <v-card
                width="20"
                height="30"
                color="#46a3fa"
                style="border-radius: 3px"
              ></v-card>
            </div>
            <div
              class="ml-2 mb-3"
              style="position: absolute; left: 0; bottom: 0"
            >
              <v-card
                width="20"
                height="18"
                color="#c8e3fc"
                style="border-radius: 3px"
              ></v-card>
            </div>
            <div style="position: absolute; bottom: 1px; left: 88px">
              <p style="font-size: 10px">137%</p>
            </div>
            <div
              class="mt-n7 mr-3"
              style="position: absolute; top: 0; right: 0"
            >
              <v-card width="200" height="70" color="transparent" elevation="0">
                <v-list-item one-line>
                  <v-list-item-content>
                    <p style="font-size: 12px">
                      The high score of new versions of assets in one month is
                      304.
                    </p>
                  </v-list-item-content>
                </v-list-item>
              </v-card>
            </div>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" lg="3">
          <v-card
            elevation="9"
            height="100"
            rounded="xl"
            :style="{ background: $vuetify.theme.themes[theme].background }"
          >
            <div class="pt-3 pl-2">
              <circlecounter
                size="5rem"
                dash-spacing="0"
                stroke-width="12"
                active-width="18"
                active-count="-35"
                rotate="-50"
                stroke="#46a3fa"
                activeStroke="#1250b8"
              >
              </circlecounter>
            </div>

            <div style="position: absolute; bottom: 26px; left: 34px">
              <p style="font-weight: 600">118</p>
            </div>
            <div style="position: absolute; bottom: 1px; left: 88px">
              <p style="font-size: 10px">137%</p>
            </div>
            <div
              class="mt-n7 mr-3"
              style="position: absolute; top: 0; right: 0"
            >
              <v-card width="200" height="70" elevation="0" color="transparent">
                <v-list-item one-line>
                  <v-list-item-content>
                    <p style="font-size: 12px">
                      118 hours were saved because of this tool!
                    </p>
                  </v-list-item-content>
                </v-list-item>
              </v-card>
            </div>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" lg="3">
          <v-card
            elevation="9"
            height="100"
            rounded="xl"
            :style="{ background: $vuetify.theme.themes[theme].background }"
          >
            <div style="position: absolute; left: 5%; top: -2.5%">
              <v-card
                width="80"
                height="8"
                color="#46a3fa"
                style="border-radius: 5px"
              ></v-card>
            </div>
            <div style="position: absolute; left: 8%; top: 6.5%">
              <v-card
                width="80"
                height="11"
                color="#1250b8"
                style="border-radius: 5px"
                ><p style="font-size: 10px" class="ml-8">36</p></v-card
              >
            </div>
            <div style="position: absolute; left: 13%; top: 18%">
              <v-card
                width="50"
                height="8"
                color="#46a3fa"
                style="border-radius: 5px"
              ></v-card>
            </div>
            <div style="position: absolute; left: 5%; top: 26.8%">
              <v-card
                width="80"
                height="8"
                color="#c8e3fc"
                style="border-radius: 5px"
              ></v-card>
            </div>
            <div style="position: absolute; bottom: 1px; left: 88px">
              <p style="font-size: 10px">137%</p>
            </div>
            <div
              class="mt-n7 mr-2"
              style="position: absolute; top: 0; right: 0"
            >
              <v-card width="200" height="70" elevation="0" color="transparent">
                <v-list-item one-line>
                  <v-list-item-content>
                    <p style="font-size: 12px">
                      36 tasks are in progress in this moment
                    </p>
                  </v-list-item-content>
                </v-list-item>
              </v-card>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </div>
    <div class="md-layout">
      <div class="md-layout-item md-size-100">
        <div class="md-layout ma-0 pa-0">
          <v-col cols="12" sm="6" lg="3" class="ma-0 pa-0 pl-1">
            <v-card
              elevation="4"
              height="45"
              style="
                background-color: rgba(52, 99, 175, 1);
                border-radius: 10px 10px 0px 0px;
              "
            >
              <v-row class="pl-8 pt-3">
                <p class="display22"><strong>Open</strong></p>
              </v-row>
            </v-card>
            <v-card
              tile
              elevation="4"
              height="400"
              class="ma-0 pa-0 mt-n4 scrollClass"
              style="background-color: rgba(182, 209, 254, 1)"
            >
              <v-content class="ma-0 pa-0">
                <v-row class="ma-0 pa-0" justify="center">
                  <changecard
                    class="mt-3"
                    :doSomething1="() => fg(item.slug)"
                    v-for="(item, index) in serverItems"
                    :key="index"
                    :idComp="item.id"
                    :color="item.color"
                    :title="item.title"
                    :subtitle="item.description"
                    :created="item.created_at"
                    :assignedTo="item.assignedTo"
                    :owner="item.owner"
                  >
                  </changecard>
                </v-row>
              </v-content>
            </v-card>
          </v-col>
          <v-col cols="12" sm="6" lg="3" class="ma-0 pa-0 pl-1">
            <v-card
              elevation="4"
              height="45"
              style="
                background-color: rgba(52, 99, 175, 0.75);
                border-radius: 10px 10px 0px 0px;
              "
              ><v-row class="pl-8 pt-3">
                <p class="display22"><strong>In Progress</strong></p>
              </v-row>
            </v-card>
            <v-card
              tile
              elevation="4"
              height="400"
              class="ma-0 pa-0 mt-n4 scrollClass"
              style="background-color: rgba(182, 209, 254, 0.75)"
            >
              <v-content class="ma-0 pa-0">
                <v-row class="ma-0 pa-0" justify="center" align="center">
                  <changecard
                    class="mt-3"
                    :doSomething1="() => fg(item.slug)"
                    v-for="(item, index) in serverItemsInProgress"
                    :key="index"
                    :idComp="item.id"
                    :color="item.color"
                    :title="item.title"
                    :subtitle="item.description"
                    :created="item.created_at"
                    :assignedTo="item.assignedTo"
                    :owner="item.owner"
                  >
                  </changecard>
                </v-row>
              </v-content>
            </v-card> </v-col
          ><v-col cols="12" sm="6" lg="3" class="ma-0 pa-0 pl-1">
            <v-card
              elevation="4"
              height="45"
              style="
                background-color: rgba(52, 99, 175, 0.5);
                border-radius: 10px 10px 0px 0px;
              "
            >
              <v-row class="pl-8 pt-3">
                <p class="display22"><strong>On hold</strong></p>
              </v-row>
            </v-card>
            <v-card
              tile
              elevation="4"
              height="400"
              class="ma-0 pa-0 mt-n4 scrollClass"
              style="background-color: rgba(182, 209, 254, 0.5)"
            >
              <v-content class="ma-0 pa-0">
                <v-row class="ma-0 pa-0" justify="center" align="center">
                  <changecard
                    class="mt-3"
                    :doSomething1="() => fg(item.slug)"
                    v-for="(item, index) in serverItemsOnHold"
                    :key="index"
                    :idComp="item.id"
                    :color="item.color"
                    :title="item.title"
                    :subtitle="item.description"
                    :created="item.created_at"
                    :assignedTo="item.assignedTo"
                    :owner="item.owner"
                  >
                  </changecard>
                </v-row>
              </v-content>
            </v-card> </v-col
          ><v-col cols="12" sm="6" lg="3" class="ma-0 pa-0 pl-1">
            <v-card
              elevation="4"
              height="45"
              style="
                background-color: rgba(52, 99, 175, 0.25);
                border-radius: 10px 10px 0px 0px;
              "
            >
              <v-row class="pl-8 pt-3">
                <p class="display22"><strong>Complete</strong></p>
              </v-row>
            </v-card>

            <v-card
              tile
              elevation="4"
              height="400"
              class="ma-0 pa-0 mt-n4 scrollClass"
              style="background-color: rgba(182, 209, 254, 0.25)"
            >
              <v-content class="ma-0 pa-0">
                <v-row class="ma-0 pa-0" justify="center" align="center">
                  <changecard
                    class="mt-3"
                    :doSomething1="() => fg(item.slug)"
                    v-for="(item, index) in serverItemsComplete"
                    :key="index"
                    :idComp="item.id"
                    :color="item.color"
                    :title="item.title"
                    :subtitle="item.description"
                    :created="item.created_at"
                    :assignedTo="item.assignedTo"
                    :owner="item.owner"
                  >
                  </changecard>
                </v-row>
              </v-content>
            </v-card>
          </v-col>
        </div>
      </div>
    </div>
    <RouterView />
  </div>
</template>

<script>
import changecard from "@/components/changecard";

import circlecounter from "vue-circle-counter";

import axios from "axios";

axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
axios.defaults.xsrfCookieName = "csrftoken";

const gradients = [
  ["#222"],
  ["#42b3f4"],
  ["red", "orange", "yellow"],
  ["purple", "violet"],
  ["#00c6ff", "#F0F", "#FF0"],
  ["#3a86ff", "#b8f2e6", "#1feaea"],
];
export default {
  name: "DashboardDashboard",

  components: {
    changecard,
    circlecounter,
  },

  data() {
    return {
      itemschangecard1: [
        {
          color: "yellow",
          title: "german capital",
          subtitle: "this is very beautiful city.",
        },
        {
          color: "blue",
          title: "king man",
          subtitle:
            "i am very happy, ok i will find you any way. it is very necessary to find this guy. ok i am fine.",
        },
        {
          color: "red",
          title: "george barno",
          subtitle: "hi i am slaman khan i like you.",
        },
      ],

      itemschangecard2: [
        {
          color: "red",
          title: "george barno",
          subtitle: "hi i am slaman khan i like you.",
        },
        {
          color: "pink",
          title: "gujar man",
          subtitle:
            "i am very happy, ok i will find you any way. it is very necessary to find this guy. ok i am fine.",
        },
      ],

      itemschangecard3: [
        {
          color: "yellow",
          title: "german capital",
          subtitle: "this is very beautiful city.",
        },
        {
          color: "pink",
          title: "gujar man",
          subtitle:
            "i am very happy, ok i will find you any way. it is very necessary to find this guy. ok i am fine.",
        },
      ],

      itemschangecard4: [
        {
          color: "pink",
          title: "gujar man",
          subtitle:
            "i am very happy, ok i will find you any way. it is very necessary to find this guy. ok i am fine.",
        },
      ],

      dailySalesChart: {
        data: {
          labels: ["M", "T", "W", "T", "F", "S", "S"],
          series: [[12, 17, 7, 17, 23, 18, 38]],
        },
        options: {
          lineSmooth: this.$chartist.Interpolation.cardinal({
            tension: 0,
          }),
          low: 0,
          high: 50, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
          chartPadding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
          },
        },
      },
      dataCompletedTasksChart: {
        data: {
          labels: ["12am", "3pm", "6pm", "9pm", "12pm", "3am", "6am", "9am"],
          series: [[230, 750, 450, 300, 280, 240, 200, 190]],
        },
        options: {
          lineSmooth: this.$chartist.Interpolation.cardinal({
            tension: 0,
          }),
          low: 0,
          high: 1000, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
          chartPadding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
          },
        },
      },
      emailsSubscriptionChart: {
        data: {
          labels: [
            "Ja",
            "Fe",
            "Ma",
            "Ap",
            "Mai",
            "Ju",
            "Jul",
            "Au",
            "Se",
            "Oc",
            "No",
            "De",
          ],
          series: [
            [542, 443, 320, 780, 553, 453, 326, 434, 568, 610, 756, 895],
          ],
        },
        options: {
          axisX: {
            showGrid: false,
          },
          low: 0,
          high: 1000,
          chartPadding: {
            top: 0,
            right: 5,
            bottom: 0,
            left: 0,
          },
        },
        responsiveOptions: [
          [
            "screen and (max-width: 640px)",
            {
              seriesBarDistance: 5,
              axisX: {
                labelInterpolationFnc: function (value) {
                  return value[0];
                },
              },
            },
          ],
        ],
      },
      headers: [
        {
          sortable: false,
          text: "ID",
          value: "id",
        },
        {
          sortable: false,
          text: "Name",
          value: "name",
        },
        {
          sortable: false,
          text: "Salary",
          value: "salary",
          align: "right",
        },
        {
          sortable: false,
          text: "Country",
          value: "country",
          align: "right",
        },
        {
          sortable: false,
          text: "City",
          value: "city",
          align: "right",
        },
      ],
      items: [
        {
          id: 1,
          name: "Dakota Rice",
          country: "Niger",
          city: "Oud-Tunrhout",
          salary: "$35,738",
        },
        {
          id: 2,
          name: "Minerva Hooper",
          country: "Curaçao",
          city: "Sinaai-Waas",
          salary: "$23,738",
        },
        {
          id: 3,
          name: "Sage Rodriguez",
          country: "Netherlands",
          city: "Overland Park",
          salary: "$56,142",
        },
        {
          id: 4,
          name: "Philip Chanley",
          country: "Korea, South",
          city: "Gloucester",
          salary: "$38,735",
        },
        {
          id: 5,
          name: "Doris Greene",
          country: "Malawi",
          city: "Feldkirchen in Kārnten",
          salary: "$63,542",
        },
      ],
      tabs: 0,
      tasks: {
        0: [
          {
            text:
              'Sign contract for "What are conference organizers afraid of?"',
            value: true,
          },
          {
            text:
              "Lines From Great Russian Literature? Or E-mails From My Boss?",
            value: false,
          },
          {
            text:
              "Flooded: One year later, assessing what was lost and what was found when a ravaging rain swept through metro Detroit",
            value: false,
          },
          {
            text: "Create 4 Invisible User Experiences you Never Knew About",
            value: true,
          },
        ],
        1: [
          {
            text:
              "Flooded: One year later, assessing what was lost and what was found when a ravaging rain swept through metro Detroit",
            value: true,
          },
          {
            text:
              'Sign contract for "What are conference organizers afraid of?"',
            value: false,
          },
        ],
        2: [
          {
            text:
              "Lines From Great Russian Literature? Or E-mails From My Boss?",
            value: false,
          },
          {
            text:
              "Flooded: One year later, assessing what was lost and what was found when a ravaging rain swept through metro Detroit",
            value: true,
          },
          {
            text:
              'Sign contract for "What are conference organizers afraid of?"',
            value: true,
          },
        ],
      },
      list: {
        0: false,
        1: false,
        2: false,
      },

      //graphs

      width: 2,
      radius: 10,
      padding: 8,
      lineCap: "round",
      gradient: gradients[5],
      value: [0, 2, 5, 9, 5, 10, 3, 5, 0, 0, 1, 8, 2, 9, 0],
      gradientDirection: "top",
      fill: false,
      type: "trend",
      autoLineWidth: false,
      labels: ["12am", "3am", "6am", "9am", "12pm", "3pm", "6pm", "9pm"],
      //graphs

      serverItems: [],
      serverItemsInProgress: [],
      serverItemsOnHold: [],
      serverItemsComplete: [],
    };
  },

  //computed
  computed: {
    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },
  },
  beforeRouteUpdate: function (to, from, next) {
    console.log(to);
    //console.log(from.path);
    let pathPre = from.path.split("/");
    if (pathPre[1] === "changespot") {
      this.getAllTasks();
    }
    //console.log(next);
    //this.$router.go(-1);
    console.log("In beforeRouteLeave of AnotherComponent");
    next();
  },
  mounted() {
    this.getAllTasks();
  },

  methods: {
    getAllTasks() {
      //to make empty before mount it again with data
      this.serverItems = [];
      this.serverItemsInProgress = [];
      this.serverItemsOnHold = [];
      this.serverItemsComplete = [];

      axios
        .get(this.$abServerPath + "/api/glbfiles/glbgetalltasks/", {
          headers: {
            "Content-Type": "application/json",
            Authorization:
              "Token " + this.getAuthCookie("augmentableUserToken") + "",
          },
        })
        .then((response) => {
          var i;
          var len;

          for (i = 0, len = response.data.length; i < len; i++) {
            var item = {
              id: "",
              slug: "",
              color: "",
              dataposition: "",
              datanormal: "",
              title: "",
              description: "",
              filename: "",
              created_at: "",
              updated_at: "",
              status: "",
              complete: "",
              assignedTo: "",
              owner: "",
            };

            item.id = response.data[i].id;
            item.slug = response.data[i].slug;
            item.color = response.data[i].color;
            item.dataposition = response.data[i].dataposition;
            item.datanormal = response.data[i].datanormal;
            item.title = response.data[i].title;
            item.description = response.data[i].description;
            item.filename = response.data[i].filename;
            item.created_at = this.dateFormat(response.data[i].created_at);
            item.updated_at = response.data[i].updated_at;
            item.status = response.data[i].status;
            item.complete = response.data[i].complete;

            item.owner = response.data[i].owner;

            item.assignedTo = response.data[i].assignedTo;
            item.owner = response.data[i].owner;

            if (response.data[i].status === "open") {
              this.serverItems.push(item);
            } else if (response.data[i].status === "inProgress") {
              this.serverItemsInProgress.push(item);
            } else if (response.data[i].status === "onHold") {
              this.serverItemsOnHold.push(item);
            } else if (response.data[i].status === "complete") {
              this.serverItemsComplete.push(item);
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
      // console.log(this.$sidebar.showSidebar);
    },
    complete(index) {
      this.list[index] = !this.list[index];
    },

    dateFormat(x) {
      return (
        "" + x.slice(8, 10) + "." + x.slice(5, 7) + "." + x.slice(0, 4) + ""
      );
    },
    fg(x) {
      this.$router.push({ name: "changeSpotD", params: { slug: x } });
    },
    getAuthCookie(cname) {
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },
  },
};
</script>


<style lang="scss" scoped>
@import "../../assets/scss/material-dashboard.scss";
@import url("https://fonts.googleapis.com/css?family=Raleway");

@import url("https://fonts.googleapis.com/css?family=Nunito+Sans");

// @import url("https://fonts.googleapis.com/css?family=Nunito Sans:200,300,400,600,700,800,900");
// * {
//   font-family: "Nunito Sans" !important;
// }

.circular-chart {
  display: block;
  margin: 10px auto;
  max-width: 80%;
  max-height: 50px;
}
.circular-chart1 {
  display: block;
  margin: 10px auto;
  max-width: 80%;
  max-height: 50px;
}

.circle {
  stroke: #4cc790;
  fill: none;
  stroke-width: 3;
  stroke-linecap: round;
  animation: progress 1s ease-out forwards;
}

@keyframes progress {
  0% {
    stroke-dasharray: 0 100;
  }
}

.scrollClass {
  overflow-y: scroll !important;
  -webkit-overflow-scrolling: touch;

  scrollbar-color: #a0a0a0 transparent;
  scrollbar-width: thin;
}

.scrollClass::-webkit-scrollbar {
  width: 5px;
}
.scrollClass::-webkit-scrollbar-track {
  background: transparent;
}
.scrollClass::-webkit-scrollbar-thumb {
  background: #a0a0a0;
  border-radius: 10px;
}
</style>